var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71875 0.46875C11.4648 0.46875 14.5 3.50391 14.5 7.25C14.5 10.9961 11.4648 14.0312 7.71875 14.0312C3.97266 14.0312 0.9375 10.9961 0.9375 7.25C0.9375 3.50391 3.97266 0.46875 7.71875 0.46875ZM9.90625 5.0625C9.41406 5.0625 9.03125 5.47266 9.03125 5.9375C9.03125 6.42969 9.41406 6.8125 9.90625 6.8125C10.3711 6.8125 10.7812 6.42969 10.7812 5.9375C10.7812 5.47266 10.3711 5.0625 9.90625 5.0625ZM5.53125 5.0625C5.03906 5.0625 4.65625 5.47266 4.65625 5.9375C4.65625 6.42969 5.03906 6.8125 5.53125 6.8125C5.99609 6.8125 6.40625 6.42969 6.40625 5.9375C6.40625 5.47266 5.99609 5.0625 5.53125 5.0625ZM10.1797 11.0508C10.5352 11.4883 11.2188 10.9141 10.8359 10.4766C10.0703 9.54688 8.92188 9 7.71875 9C6.48828 9 5.33984 9.54688 4.57422 10.4766C4.19141 10.9141 4.875 11.4883 5.23047 11.0508C5.85938 10.3125 6.76172 9.875 7.71875 9.875C8.64844 9.875 9.55078 10.3125 10.1797 11.0508Z",
    fill: "#FF3E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.8019abd9779350a4059c5ff0ce098ac7.svg";
export { ForwardRef as ReactComponent };